const EditarIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.67465 8.83451L1.67396 8.83521C1.65331 8.85574 1.64054 8.8826 1.63757 8.91121C1.63756 8.91129 1.63755 8.91138 1.63754 8.91146L1.25068 12.7815C1.25068 12.7816 1.25067 12.7817 1.25066 12.7817C1.24308 12.8595 1.30874 12.927 1.38951 12.9192C1.38952 12.9192 1.38952 12.9192 1.38953 12.9192L5.27765 12.5427C5.30741 12.5398 5.33495 12.5267 5.35568 12.506L5.35609 12.5056L12.2828 5.59151C12.2828 5.59151 12.2828 5.59151 12.2828 5.59151C12.9577 4.91776 12.9577 3.80814 12.2828 3.13439L12.2826 3.13421L11.0655 1.91808C10.6952 1.54853 10.2624 1.38019 9.84245 1.38086L1.67465 8.83451ZM1.67465 8.83451L8.59845 1.92091M1.67465 8.83451L8.59845 1.92091M11.7494 3.66556L12.1026 3.31168L10.8853 2.09659C10.6276 1.83941 10.2848 1.65062 9.89201 1.63197L11.7494 3.66556ZM11.7494 3.66556L12.1026 3.31168C12.693 3.90103 12.693 4.82485 12.1026 5.41422L12.1026 5.41422L11.1706 6.34449L10.8174 6.69708L10.4642 6.34449L7.84951 3.7346L7.49499 3.38073L7.84951 3.02685L8.78148 2.09658C9.10236 1.77628 9.4889 1.61283 9.89197 1.63197L11.7494 3.66556ZM8.59845 1.92091C8.98089 1.55196 9.42183 1.38186 9.84221 1.38086L8.59845 1.92091ZM2.65666 9.47384L1.91014 8.72912L1.80598 9.77843L1.58064 12.0485L1.5205 12.6544L2.12651 12.5955L4.40561 12.3743L5.46138 12.2718L4.71042 11.5226L2.65666 9.47384Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
};

export default EditarIcon;
